import axios from 'axios';
import * as endPoints from '../../Constants/Endpoints'


export function GetConfig() {
    return axios.get(
        process.env.REACT_APP_API_SERVICE_BASE_URL + endPoints.GetConfig,
    {
        headers: {
            "Content-Type": "application/json"
        },
        withCredentials: true
    });
}

export function GetPaymentServiceDetails() {
    return axios.get(
        process.env.REACT_APP_API_SERVICE_BASE_URL + endPoints.GetPaymentServiceDetails,
    {
        headers: {
            "Content-Type": "application/json"
        },
        withCredentials: true
    });
}

export function UpdateAcceptOnlinePaymentsOption(optionValue) {
    const option = {
        optionValue    
    }
    return axios.put(
        process.env.REACT_APP_API_SERVICE_BASE_URL + endPoints.AcceptOnlinePaymentsOptionUpdate, option,
    {
        headers: {
            "Content-Type": "application/json"
        },
        withCredentials: true
    });
}

export function DisconnectStripeAccount() {

    return axios.delete(
        process.env.REACT_APP_API_SERVICE_BASE_URL + endPoints.DisconnectStripeAccount,
    {
        headers: {
            "Content-Type": "application/json"
        },
        withCredentials: true
    });
}

export function GetLoginLink() {
    return axios.get(
        process.env.REACT_APP_API_SERVICE_BASE_URL + endPoints.ConnectStripeLoginLink,
    {
        headers: {
            "Content-Type": "application/json"
        },
        withCredentials: true
    });
}

export function PutAppointmentsConfig(cancellationThreshold, bookingThreshold) {
    const appointmentConfigDetails = {
        cancellationThreshold,
        bookingThreshold
    }
    return axios.put(
        process.env.REACT_APP_API_SERVICE_BASE_URL + endPoints.AppointmentConfig, appointmentConfigDetails,
    {
        headers: {
            "Content-Type": "application/json"
        },
        withCredentials: true
    });
}

export function PutLangConfig(SystemLanguage, BookingLanguage, EmailLanguage) {
    const langConfigDto = {
        SystemLanguage,
        BookingLanguage,
        EmailLanguage
    }
    return axios.put(
        process.env.REACT_APP_API_SERVICE_BASE_URL + endPoints.LangConfig, langConfigDto,
    {
        headers: {
            "Content-Type": "application/json"
        },
        withCredentials: true
    });
}
export function GetMembershipDetails() {
  return axios.get(
    process.env.REACT_APP_API_SERVICE_BASE_URL + endPoints.Subscription,
    {
      headers: { "Content-Type": "application/json" },
      withCredentials: true
    }
  );
}

export function GetAllowedPlans() {
  return axios.get(
    process.env.REACT_APP_API_SERVICE_BASE_URL + endPoints.AllowedPlans,
    {
      headers: { "Content-Type": "application/json" },
      withCredentials: true
    }
  );
}

export function CreateBillingPortalSession() {
  return axios.post(
    process.env.REACT_APP_API_SERVICE_BASE_URL + endPoints.BillingPortal,
    {},
    {
      headers: { "Content-Type": "application/json" },
      withCredentials: true
    }
  );
}

export function PutCalendarConfig(durationBlock, BreakEventColour) {
    const calendarConfigDetails = {
        durationBlock,
        BreakEventColour
        }
    return axios.put(
        process.env.REACT_APP_API_SERVICE_BASE_URL + endPoints.CalendarConfig, calendarConfigDetails,
    {
        headers: {
            "Content-Type": "application/json"
        },
        withCredentials: true
    });
}

export function ConnectStripeAccount() {
    return axios.post(
        process.env.REACT_APP_API_SERVICE_BASE_URL + endPoints.ConnectStripeAccount,null,
    {
        headers: {
            "Content-Type": "application/json"
        },
        withCredentials: true
    });
}

export function PutAccountDetailsConfig(shopName, phoneNumber, timeZone) {
    const accountDetailsConfigDetails = {
        shopName,
        phoneNumber,
        timeZone
    }
    return axios.put(
        process.env.REACT_APP_API_SERVICE_BASE_URL + endPoints.AccountDetailsConfig, accountDetailsConfigDetails,
    {
        headers: {
            "Content-Type": "application/json"
        },
        withCredentials: true
    });
}

export function ResetDemoAccount() {
    return axios.get(
        process.env.REACT_APP_API_SERVICE_BASE_URL + endPoints.ResetDemoAccount,
    {
        headers: {
            "Content-Type": "application/json"
        },
        withCredentials: true
    });
}

export function PutNotificationsConfig(notificationId, value) {
    const notificationConfigDetails = {
        notificationId,
        value,

    }
    return axios.put(
        process.env.REACT_APP_API_SERVICE_BASE_URL + endPoints.NotificationsDetailsConfig, notificationConfigDetails,
    {
        headers: {
            "Content-Type": "application/json"
        },
        withCredentials: true
    });
}

export function UpdateEmail(oldEmail, newEmail, verificationCode) {
    const updateEmailDetails = {
        oldEmail,
        newEmail,
        verificationCode

    }
    return axios.put(
        process.env.REACT_APP_API_SERVICE_BASE_URL + endPoints.UpdateEmail, updateEmailDetails,
    {
        headers: {
            "Content-Type": "application/json"
        },
        withCredentials: true
    });
}

export function UpdatePassword(currentPassword, password, passwordTwo, verificationCode) {
    const updatePasswordDetails = {
        currentPassword,
        password,
        passwordTwo,
        verificationCode

    }
    return axios.put(
        process.env.REACT_APP_API_SERVICE_BASE_URL + endPoints.UpdatePassword, updatePasswordDetails,
    {
        headers: {
            "Content-Type": "application/json"
        },
        withCredentials: true
    });
}

export function VerificationCode(reason, email) {
    const verificationCode = {
        reason,
        email
    }
    return axios.post(
        process.env.REACT_APP_API_SERVICE_BASE_URL + endPoints.VerificationCode, verificationCode,
    {
        headers: {
            "Content-Type": "application/json"
        },
        withCredentials: true
    });
}

export function SendTestConfirmationEmail() {

    return axios.get(
        process.env.REACT_APP_API_SERVICE_BASE_URL + endPoints.SendTestConfirmationEmail,
    {
        headers: {
            "Content-Type": "application/json"
        },
        withCredentials: true
    });
}

export function PutCustomerisationCommunicationsConfig(AppointmentConfirmationMessageToCustomer, AppointmentReminderNotesToCustomer, AppointmentCancellationPolicyToCustomer, AppointmentChangedMessageToCustomer, AppointmentCancellationMessageToCustomer) {
    const customerisationCommunicationsConfigDetails = {
        AppointmentConfirmationMessageToCustomer,
        AppointmentReminderNotesToCustomer,
        AppointmentCancellationPolicyToCustomer,
        AppointmentChangedMessageToCustomer,
        AppointmentCancellationMessageToCustomer
    }
    return axios.put(
        process.env.REACT_APP_API_SERVICE_BASE_URL + endPoints.CustomerisationCommunicationsConfig, customerisationCommunicationsConfigDetails,
    {
        headers: {
            "Content-Type": "application/json"
        },
        withCredentials: true
    });
}
